module.exports = new __parcel__URL__("logo-light.d8b281ea.png").toString();